import {
    ChevronRight,
} from "lucide-react";
import RecommendationProductCard from "../RecommendationProductCard";
import {
    getRecommendationProducts,
} from "../RecommendationProductsData";
import "./RelevantItemsSection.css";

type RelevantItemsSectionProps = {
    category?: string;
};

const RelevantItemsSection = ({
    category,
}: RelevantItemsSectionProps) => {
    const products =
        getRecommendationProducts(
            category,
            "relevant"
        );

    return (
        <section className="relevant-items">
            <div className="relevant-items-container">
                <div className="relevant-items-header">
                    <div>
                        <span>
                            PERSONALISED PICKS
                        </span>

                        <h2>
                            More products you may like
                        </h2>

                        <p>
                            Relevant options selected from similar products, shopper activity and current trends.
                        </p>
                    </div>

                    <button type="button">
                        Browse more

                        <ChevronRight
                            size={16}
                        />
                    </button>
                </div>

                <div className="relevant-items-grid">
                    {products.map(
                        (
                            product
                        ) => (
                            <RecommendationProductCard
                                key={
                                    product.id
                                }
                                product={
                                    product
                                }
                            />
                        )
                    )}
                </div>
            </div>
        </section>
    );
};

export default RelevantItemsSection;